import * as React from 'react';
import Axis from '../Axis';
import { jsx as _jsx } from "react/jsx-runtime";
const YAxis = ({
  type = 'linear',
  ...restProps
}) => /*#__PURE__*/_jsx(Axis, {
  type: type,
  ...restProps,
  isX: false
});
YAxis.displayName = 'YAxis';
YAxis.Title = Axis.Title;
export default YAxis;